import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvConfig } from '@shared/definitions';
import { ENV_CONFIG } from '@digilize/shared/utils/tokens';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AreasService {
  private readonly baseUrl = `${this.config.api}/v1.0/areas`;

  constructor(@Inject(ENV_CONFIG) private readonly config: EnvConfig, private readonly client: HttpClient) {}

  getAreaSVG(areaId: string, theme: number): Observable<string> {
    return this.client.get(`${this.baseUrl}/${areaId}/${theme}/seats/download`, { responseType: 'text' });
  }
}
